import { DEFAULT_PAGE_LIMIT } from '../constants';

const countSkip = (pageNumber, pageSize = DEFAULT_PAGE_LIMIT) => {
  const skip = (pageNumber - 1) * pageSize;
  return skip;
};

export default countSkip;
